import { lazy, useContext, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import DisableDevtool from 'disable-devtool'

import Instructions from '@/pages/Assessment/Instructions.jsx'
import { AuthContext } from '@/contexts/AuthContext.js'
import { AUTHOR, MENTOR } from '@/enums/userRoles.js'

const Attempt = lazy(() => import('@/pages/Attempt/index'))
const Report = lazy(() => import('@/pages/Attempt/Report/index'))

const AssessmentRouter = () => {
    const { kalviumKc } = useContext(AuthContext)

    useEffect(() => {
        // Only disable devtools in production
        if (import.meta.env.VITE_ENV !== 'production') {
            return
        }

        DisableDevtool({
            ignore: () => {
                // Disable devtool is ignored when user is author or mentor
                return kalviumKc.hasRole([AUTHOR, MENTOR])
            },
            ondevtoolopen: (type, next) => {
                alert('Oh, you sneaky fella! We know what you\'re trying to do. Now let\'s get back to the assessment, shall we?')
                next() // This closes the current window
            }
        })
    }, [kalviumKc])

    return (
        <Routes>
            <Route path={':ax_slug'} element={<Instructions />} />
            <Route path={':ax_slug/attempt/:attempt_id'} element={<Attempt />} />
            <Route
                path={':ax_slug/attempt/:attempt_id/report'}
                element={<Report />}
            />
        </Routes>
    )
}

export default AssessmentRouter
